import { TitleWithMargin, Wrapper } from '../styles'
import { PageSectionSecondary } from 'ui/components'
import { Hr } from 'ui/components/Hr'

import { LicenseInformationProps } from './LicenseInformationProps'
import { AddressInformation, LicenseDetails } from './components'

export const LicenseInformation = ({ licenses }: LicenseInformationProps) => (
  <Wrapper>
    <TitleWithMargin>License Information</TitleWithMargin>
    {licenses.map((license, index) => (
      <PageSectionSecondary key={index} face={'solid'} title={`License #${index + 1}`}>
        <LicenseDetails license={license} />
        <Hr />
        <AddressInformation license={license} />
      </PageSectionSecondary>
    ))}
  </Wrapper>
)
